import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

export function useApi(path, params) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const key = JSON.stringify(params || {});
  useEffect(() => {
    let alive = true;
    const t = setTimeout(() => {
      api.get(path, { params: JSON.parse(key) })
        .then((r) => { if (alive) { setData(r.data); setError(""); } })
        .catch((e) => { if (alive) setError(errMsg(e)); });
    }, params ? 250 : 0);
    return () => { alive = false; clearTimeout(t); };
  }, [path, key]); // eslint-disable-line react-hooks/exhaustive-deps
  return { data, error, setData };
}

export const Status = ({ data, error }) => {
  if (error) return <p className="err" data-testid="load-error">{error}</p>;
  if (!data) return <p className="note" data-testid="loading">Cargando…</p>;
  return null;
};

export const EmptyData = () => (
  <p className="note" data-testid="no-data">Aún no hay datos cargados. Un administrador puede cargarlos en Administración › Importar datos (JSON).</p>
);
